module.exports = __webpack_public_path__ + "static/island-logo-hover-900a59c4b00c7c8184498b71219c3a13.png";